module.exports = __webpack_public_path__ + "static/media/tep-nav.3c24fccd.png";